import { render, staticRenderFns } from "./AllBsiContinuousFilingSubmissions.vue?vue&type=template&id=50e047e7&scoped=true&"
import script from "./AllBsiContinuousFilingSubmissions.vue?vue&type=script&lang=js&"
export * from "./AllBsiContinuousFilingSubmissions.vue?vue&type=script&lang=js&"
import style0 from "./AllBsiContinuousFilingSubmissions.vue?vue&type=style&index=0&id=50e047e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e047e7",
  null
  
)

export default component.exports